import React from 'react';
import { connect } from 'react-redux';
import { getTranslatedString } from 'helpers/i18n';
import { imageAcceptedFileTypes } from 'helpers/FileHelper';

import SingleFileUpload from 'components/ui/SingleFileUpload/SingleFileUpload';
import Form from 'components/ui/Form';

const config = {
  ATTACHMENT_SIZE: 6 * 1000000, // 6mb
  IMAGE_SIZE: 3 * 1000000,
};

const ImageInput = ({ values, setFieldValue, setFieldTouched }) => {
  const handleChange = (image) => {
    setFieldValue('notice_image', image);
    setFieldTouched('notice_image', true);
    setFieldValue('remove_image', !image);
  };

  return (
    <Form.Item
      label={getTranslatedString('landlordPortal.noticeTemplateForm.ifYouWouldLikeToDraw')}
    >
      <SingleFileUpload
        file={values.notice_image}
        name="notice_image"
        onChange={handleChange}
        onDropVerbiage={getTranslatedString('landlordPortal.noticeForm.attachments.dropFileHere')}
        dropFileVerbiage={getTranslatedString('landlordPortal.noticeForm.attachments.dragAndDrop')}
        browseVerbiage={getTranslatedString('landlordPortal.noticeForm.attachments.browse')}
        rejectFileError={getTranslatedString(
          'landlordPortal.noticeForm.attachments.cannotAcceptFile'
        )}
        maxSize={config.IMAGE_SIZE}
        acceptedFiles={imageAcceptedFileTypes}
      />
    </Form.Item>
  );
};

export default connect((store) => {
  return {};
}, {})(ImageInput);
